import * as React from 'react';
import { useAppState } from '../core/redux/hooks';
import { useMsgText } from './hooks';


interface Props extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  /**
   * The translation key to lookup for the input's placeholder value
   */
  placeholderTranslation: string;

  /**
   * Fallback text to be used for the translated placeholder string can't be found
   */
  placeholderDefault?: string;
}


/**
 * LocalInput: an input component that accepts all the normal input props and renders all placeholder and user-entered
 * text within the component, without being overridden by the Text Direction in Redux.
 *
 * Props:
 * 1. The `placeholderTranslation` prop is your translation key that is used to look up the appropriate translation for
 * the placeholder text in Redux.
 * 1. The `placeholderDefault` prop allows you to specify placeholder text for when a translation isn't found (defaults
 * to empty string). If this prop is not defined, a default message will be used (if one has been defined).
 *
 * PureComponent: true
 * Redux Connected: true
 */
const LocalInput: React.FC<Props> = (props) => {
  // Destructure to appease React
  const { placeholderTranslation, placeholderDefault, ...rest } = props;

  const translation = useMsgText(placeholderTranslation, placeholderDefault);

  const dir = useAppState(state => state.locale.textDirection);

  return (
    <input {...rest} dir={dir} placeholder={translation} />
  );
};

LocalInput.defaultProps = {
  placeholderDefault: '',
};

export default LocalInput;